import { useEffect, useState } from 'react'

// A legacy Sprockets utility class also named `.hidden` (app/assets/stylesheets/application/_helpers.scss)
// ships `display: none !important` outside any cascade layer, which always beats Tailwind's
// layered `hidden`/`{breakpoint}:block` utilities on pages that still load that legacy
// stylesheet (the default `application` layout) - the element stays hidden at every viewport.
// Components that need to show/hide by breakpoint inside a mixed legacy/Tailwind page must
// drive it from this hook instead of the `hidden md:block` class pattern.
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => typeof window !== 'undefined' ? window.matchMedia(query).matches : false)

  useEffect(() => {
    const mediaQuery = window.matchMedia(query)
    const handleChange = () => setMatches(mediaQuery.matches)
    handleChange()
    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [query])

  return matches
}
